/**
 * A function that returns JSX for the AuthText component, displaying a series of paragraphs with information about the application's features and benefits.
 *
 * @return {JSX.Element} The JSX for the AuthText component
 */
const AuthText = () => {
  const para = [
    "This cutting edge application has streamlined the sign up and job  uploading process dramatically. Convenient and efficient, this bespoke system has been designed and developed around you.",
    "With a simple walkthrough guide and step by step instructions, it has never been easier to register with a locum agency. Advertise your jobs free of charge to our robust database of experienced locums.",
    "With advanced security, all details are completely secure and safe on our system.",
    "Find local locums to you and prioritise your favourites to quick search them and their availability in the future.",
    "Become apart of the most progressive medical recruitment industry  in the market.",
    "Sign up now.",
  ];
  return (
    <div className="flex grow flex-col gap-6">
      <h2 className="text-[26px] font-bold leading-[normal] text-primary lg:text-[32px]">
        The easiest and most user-friendly sign-up process yet!
      </h2>
      <div className="flex flex-col gap-4">
        {para.map((item, index) => {
          return (
            <p
              className="!w[5vw] m-0 text-[16px] font-normal text-black lg:text-[18px]"
              key={index}
            >
              {item}
            </p>
          );
        })}
      </div>
    </div>
  );
};

export default AuthText;
